import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { EmailConfirmed } from "./pages/EmailConfirmed/EmailConfirmed";
import { App } from "antd";
import { ForgotPassword } from "./pages/ForgotPassword/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword/ResetPassword";
import { ToU } from "./pages/ToU/ToU";
import { GTS } from "./pages/GTS/GTS";
import { HomePage } from "./pages/HomePage/HomePage";
import { NotFound } from "./pages/NotFound/NotFound";
import { ChekerVerification } from "./pages/ChekerVerification/ChekerVerification";
import { ChekerVerificationFinished } from "./pages/ChekerVerificationFinished/ChekerVerificationFinished";
import { PrivacyPolicy } from "./pages/PrivacyPolicy/PrivacyPolicy";
import { DeleteAccount } from "./pages/DeleteAccount/DeleteAccount";
import Unsubscribe from "./pages/Unsubscribe/Unsubscribe";

function MyApp() {
    return (
        <App>
            <BrowserRouter>
                <Routes>
                    <Route
                        path="/email-confirmed"
                        element={<EmailConfirmed />}
                    />
                    <Route
                        path="/forgot-password"
                        element={<ForgotPassword />}
                    />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/terms-of-use" element={<ToU />} />
                    <Route path="/general-terms-of-sale" element={<GTS />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route
                        path="/glitter-confirmation"
                        element={<ChekerVerification />}
                    />
                    <Route
                        path="/glitter-verification-finished"
                        element={<ChekerVerificationFinished />}
                    />
                    <Route path="/unsubscribe" element={<Unsubscribe />} />
                    <Route path="/delete-account" element={<DeleteAccount />} />
                    <Route path="/" element={<HomePage />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
        </App>
    );
}

export default MyApp;
